export enum CullMode {
    /** Disable culling. */
    Off = 0,
    /** cut the front-face of the polygons. */
    Front = 1,
    /** cut the back-face of the polygons. */
    Back = 2
  }
  